module.exports = __webpack_public_path__ + "static/media/15.9bf4b14b.wav";